export const FIRST_BREAKPOINT = 790;
export const SECOND_BREAKPOINT = 570;
export const THIRD_BREAKPOINT = 375;
export const FOURTH_BREAKPOINT = 370;
